<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="getOut()">
        <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>

  <!-- Contenido -->
  <h3 class="ion-text-center primary-text">
    <strong>{{ title }}</strong>
  </h3>
  <h5 class="ion-text-center secondary-text no-margin">
    {{ restriction }}
  </h5>
  <ion-card>
    <ion-card-content class="ion-text-center">

      <!-- Listado de archivos -->
      <ion-list class="ion-no-border col-card">

        <!-- Listado de archivos en base de datos -->
        <ion-item *ngFor="let file of fileStore; let i=index" class="file-item">
          <ion-label>
            <ion-text color="secondary">
              {{ file.originalName }}
            </ion-text>
          </ion-label>
          <ion-button (click)="openFile(file)" fill="clear" slot="end" color="secondary">
            <ion-icon name="eye"></ion-icon>
          </ion-button>
          <ion-button *ngIf="eventDelete" (click)="deleteFile(file)" fill="clear" slot="end">
            <ion-icon name="trash" color="danger"></ion-icon>
          </ion-button>
        </ion-item>

        <!-- Listado de archivos procesando -->
        <ion-item *ngFor="let file of processingFiles;">
          <ion-label>
            <ion-text color="secondary">
              {{ file.originalName }}
            </ion-text>
          </ion-label>
          <ion-button fill="clear" slot="end">
            <ion-spinner name="dots"></ion-spinner>
          </ion-button>
        </ion-item>
      </ion-list>

      <!-- Botón para agregar archivos -->
      <ion-button *ngIf="(!fileStore || fileStore.length < maxFiles) && eventUpload" fill="outline" (click)="selectFile()" color="secondary">
        {{ buttonTitle }}
        <ion-icon slot="end" name="attach" color="secondary" class="img-rotate-45 img20"></ion-icon>
      </ion-button>

    </ion-card-content>
  </ion-card>

  <ion-row class="ion-text-center btn-bottom">
    <!-- Botón para guardar archivos -->
    <ion-button *ngIf="(fileStore && fileStore.length > 0) && eventUpload" fill="solid" (click)="getOut()"
      color="primary btn-center" [disabled]='processingFiles.length'>
      Guardar
      <ion-icon slot="end" name="save" color="secondary"></ion-icon>
    </ion-button>
  </ion-row>

  <input type="file" id="file-input" name="img" [accept]="accept" (change)="obtainImage($event)" style="display:none">

</ion-content>